export default {
  "animals": [
    {
      "id": "40600671980896",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 65,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "512.20",
      "peso_final_carcaca_1": "163.70",
      "peso_final_carcaca_2": "170.70",
      "total_carcaca": "334.40",
      "rendimento": "65.29",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291907",
      "ind_dt_register_sagria": "2019-05-24T09:59:47.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:27:15.000Z",
      "dt_register": "2019-06-17T15:05:15.000Z",
      "dt_update": "2019-06-17T15:05:15.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40602232790825",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 66,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "531.20",
      "peso_final_carcaca_1": "163.50",
      "peso_final_carcaca_2": "170.10",
      "total_carcaca": "333.60",
      "rendimento": "62.80",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291908",
      "ind_dt_register_sagria": "2019-05-24T10:00:07.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:28:06.000Z",
      "dt_register": "2019-06-17T15:05:16.000Z",
      "dt_update": "2019-06-17T15:05:16.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40603793574741",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 67,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "535.20",
      "peso_final_carcaca_1": "167.50",
      "peso_final_carcaca_2": "174.10",
      "total_carcaca": "341.60",
      "rendimento": "63.83",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291909",
      "ind_dt_register_sagria": "2019-05-24T10:00:17.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:28:40.000Z",
      "dt_register": "2019-06-17T15:05:16.000Z",
      "dt_update": "2019-06-17T15:05:16.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40605354358657",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 68,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "576.20",
      "peso_final_carcaca_1": "167.10",
      "peso_final_carcaca_2": "171.90",
      "total_carcaca": "339.00",
      "rendimento": "58.83",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291910",
      "ind_dt_register_sagria": "2019-05-24T10:00:37.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:29:13.000Z",
      "dt_register": "2019-06-17T15:05:16.000Z",
      "dt_update": "2019-06-17T15:05:16.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40606915168590",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 69,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "540.20",
      "peso_final_carcaca_1": "167.30",
      "peso_final_carcaca_2": "172.90",
      "total_carcaca": "340.20",
      "rendimento": "62.98",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291911",
      "ind_dt_register_sagria": "2019-05-24T10:01:35.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:30:03.000Z",
      "dt_register": "2019-06-17T15:05:17.000Z",
      "dt_update": "2019-06-17T15:05:17.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40608475952507",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 70,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "568.20",
      "peso_final_carcaca_1": "162.50",
      "peso_final_carcaca_2": "164.70",
      "total_carcaca": "327.20",
      "rendimento": "57.59",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291912",
      "ind_dt_register_sagria": "2019-05-24T10:02:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:30:37.000Z",
      "dt_register": "2019-06-17T15:05:17.000Z",
      "dt_update": "2019-06-17T15:05:17.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40610036736424",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 71,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "562.20",
      "peso_final_carcaca_1": "153.30",
      "peso_final_carcaca_2": "157.90",
      "total_carcaca": "311.20",
      "rendimento": "55.35",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291913",
      "ind_dt_register_sagria": "2019-05-24T10:02:34.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:31:09.000Z",
      "dt_register": "2019-06-17T15:05:17.000Z",
      "dt_update": "2019-06-17T15:05:17.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40611597520341",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 72,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "597.20",
      "peso_final_carcaca_1": "158.10",
      "peso_final_carcaca_2": "164.90",
      "total_carcaca": "323.00",
      "rendimento": "54.09",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291914",
      "ind_dt_register_sagria": "2019-05-24T10:02:51.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:42:57.000Z",
      "dt_register": "2019-06-17T15:05:17.000Z",
      "dt_update": "2019-06-17T15:05:17.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40613158330279",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 73,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "571.20",
      "peso_final_carcaca_1": "172.90",
      "peso_final_carcaca_2": "181.30",
      "total_carcaca": "354.20",
      "rendimento": "62.01",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291915",
      "ind_dt_register_sagria": "2019-05-24T10:04:39.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:32:32.000Z",
      "dt_register": "2019-06-17T15:05:18.000Z",
      "dt_update": "2019-06-17T15:05:18.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40614719114197",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 74,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "556.20",
      "peso_final_carcaca_1": "147.50",
      "peso_final_carcaca_2": "154.90",
      "total_carcaca": "302.40",
      "rendimento": "54.37",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291916",
      "ind_dt_register_sagria": "2019-05-24T10:04:49.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:33:22.000Z",
      "dt_register": "2019-06-17T15:05:18.000Z",
      "dt_update": "2019-06-17T15:05:18.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40616279898115",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 75,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "552.20",
      "peso_final_carcaca_1": "158.50",
      "peso_final_carcaca_2": "166.00",
      "total_carcaca": "324.50",
      "rendimento": "58.76",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 4,
      "destino_id": 6,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291917",
      "ind_dt_register_sagria": "2019-05-24T10:05:26.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:28:09.000Z",
      "dt_register": "2019-06-17T15:05:18.000Z",
      "dt_update": "2019-06-17T15:05:18.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40617840708057",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 76,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "582.20",
      "peso_final_carcaca_1": "158.90",
      "peso_final_carcaca_2": "162.90",
      "total_carcaca": "321.80",
      "rendimento": "55.27",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291918",
      "ind_dt_register_sagria": "2019-05-24T10:05:51.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:34:14.000Z",
      "dt_register": "2019-06-17T15:05:19.000Z",
      "dt_update": "2019-06-17T15:05:19.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40619401491976",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 77,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "531.20",
      "peso_final_carcaca_1": "164.10",
      "peso_final_carcaca_2": "168.90",
      "total_carcaca": "333.00",
      "rendimento": "62.69",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291919",
      "ind_dt_register_sagria": "2019-05-24T10:08:29.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:35:14.000Z",
      "dt_register": "2019-06-17T15:05:19.000Z",
      "dt_update": "2019-06-17T15:05:19.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40620962301921",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 78,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "535.20",
      "peso_final_carcaca_1": "171.90",
      "peso_final_carcaca_2": "175.90",
      "total_carcaca": "347.80",
      "rendimento": "64.99",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291920",
      "ind_dt_register_sagria": "2019-05-24T10:08:40.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:35:50.000Z",
      "dt_register": "2019-06-17T15:05:20.000Z",
      "dt_update": "2019-06-17T15:05:20.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40622523085841",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 79,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "556.20",
      "peso_final_carcaca_1": "169.30",
      "peso_final_carcaca_2": "176.10",
      "total_carcaca": "345.40",
      "rendimento": "62.10",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291921",
      "ind_dt_register_sagria": "2019-05-24T10:08:54.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:36:54.000Z",
      "dt_register": "2019-06-17T15:05:20.000Z",
      "dt_update": "2019-06-17T15:05:20.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40624083869761",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 80,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "566.20",
      "peso_final_carcaca_1": "178.90",
      "peso_final_carcaca_2": "184.70",
      "total_carcaca": "363.60",
      "rendimento": "64.22",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291922",
      "ind_dt_register_sagria": "2019-05-24T10:09:10.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:37:28.000Z",
      "dt_register": "2019-06-17T15:05:20.000Z",
      "dt_update": "2019-06-17T15:05:20.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40625644679710",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 81,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "564.20",
      "peso_final_carcaca_1": "164.10",
      "peso_final_carcaca_2": "174.10",
      "total_carcaca": "338.20",
      "rendimento": "59.94",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291923",
      "ind_dt_register_sagria": "2019-05-24T10:11:03.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:38:42.000Z",
      "dt_register": "2019-06-17T15:05:21.000Z",
      "dt_update": "2019-06-17T15:05:21.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40627205463631",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 82,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "590.20",
      "peso_final_carcaca_1": "149.10",
      "peso_final_carcaca_2": "154.30",
      "total_carcaca": "303.40",
      "rendimento": "51.41",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291924",
      "ind_dt_register_sagria": "2019-05-24T10:11:13.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:39:16.000Z",
      "dt_register": "2019-06-17T15:05:21.000Z",
      "dt_update": "2019-06-17T15:05:21.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40628766247552",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 83,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "599.20",
      "peso_final_carcaca_1": "151.30",
      "peso_final_carcaca_2": "159.30",
      "total_carcaca": "310.60",
      "rendimento": "51.84",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291925",
      "ind_dt_register_sagria": "2019-05-24T10:11:26.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:39:50.000Z",
      "dt_register": "2019-06-17T15:05:21.000Z",
      "dt_update": "2019-06-17T15:05:21.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40630327031473",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 84,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "533.20",
      "peso_final_carcaca_1": "161.70",
      "peso_final_carcaca_2": "169.90",
      "total_carcaca": "331.60",
      "rendimento": "62.19",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291926",
      "ind_dt_register_sagria": "2019-05-24T10:11:37.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:40:25.000Z",
      "dt_register": "2019-06-17T15:05:21.000Z",
      "dt_update": "2019-06-17T15:05:21.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40631887841427",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 85,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "555.20",
      "peso_final_carcaca_1": "166.50",
      "peso_final_carcaca_2": "170.30",
      "total_carcaca": "336.80",
      "rendimento": "60.66",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291927",
      "ind_dt_register_sagria": "2019-05-24T10:13:00.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:40:59.000Z",
      "dt_register": "2019-06-17T15:05:22.000Z",
      "dt_update": "2019-06-17T15:05:22.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40633448625349",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 86,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "567.20",
      "peso_final_carcaca_1": "157.10",
      "peso_final_carcaca_2": "164.90",
      "total_carcaca": "322.00",
      "rendimento": "56.77",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291928",
      "ind_dt_register_sagria": "2019-05-24T10:13:18.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:41:33.000Z",
      "dt_register": "2019-06-17T15:05:22.000Z",
      "dt_update": "2019-06-17T15:05:22.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40635009435306",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 87,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "580.20",
      "peso_final_carcaca_1": "154.90",
      "peso_final_carcaca_2": "158.70",
      "total_carcaca": "313.60",
      "rendimento": "54.05",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291929",
      "ind_dt_register_sagria": "2019-05-24T10:18:06.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:44:21.000Z",
      "dt_register": "2019-06-17T15:05:23.000Z",
      "dt_update": "2019-06-17T15:05:23.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40636570219229",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 88,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "566.20",
      "peso_final_carcaca_1": "156.70",
      "peso_final_carcaca_2": "164.50",
      "total_carcaca": "321.20",
      "rendimento": "56.73",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291930",
      "ind_dt_register_sagria": "2019-05-24T10:18:27.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:44:55.000Z",
      "dt_register": "2019-06-17T15:05:23.000Z",
      "dt_update": "2019-06-17T15:05:23.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40638131003152",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 89,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "543.20",
      "peso_final_carcaca_1": "156.90",
      "peso_final_carcaca_2": "163.50",
      "total_carcaca": "320.40",
      "rendimento": "58.98",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291931",
      "ind_dt_register_sagria": "2019-05-24T10:20:12.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:45:46.000Z",
      "dt_register": "2019-06-17T15:05:23.000Z",
      "dt_update": "2019-06-17T15:05:23.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40639691787075",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 90,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "512.20",
      "peso_final_carcaca_1": "161.50",
      "peso_final_carcaca_2": "164.50",
      "total_carcaca": "326.00",
      "rendimento": "63.65",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 6,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291932",
      "ind_dt_register_sagria": "2019-05-24T10:20:35.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:27:55.000Z",
      "dt_register": "2019-06-17T15:05:23.000Z",
      "dt_update": "2019-06-17T15:05:23.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40641252597037",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 91,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "548.20",
      "peso_final_carcaca_1": "164.70",
      "peso_final_carcaca_2": "172.10",
      "total_carcaca": "336.80",
      "rendimento": "61.44",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291933",
      "ind_dt_register_sagria": "2019-05-24T10:21:16.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:47:45.000Z",
      "dt_register": "2019-06-17T15:05:24.000Z",
      "dt_update": "2019-06-17T15:05:24.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40642813380961",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 92,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "562.20",
      "peso_final_carcaca_1": "162.90",
      "peso_final_carcaca_2": "167.70",
      "total_carcaca": "330.60",
      "rendimento": "58.80",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291934",
      "ind_dt_register_sagria": "2019-05-24T10:22:42.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:48:19.000Z",
      "dt_register": "2019-06-17T15:05:24.000Z",
      "dt_update": "2019-06-17T15:05:24.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40644374164885",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 93,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "583.20",
      "peso_final_carcaca_1": "156.10",
      "peso_final_carcaca_2": "161.90",
      "total_carcaca": "318.00",
      "rendimento": "54.53",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291935",
      "ind_dt_register_sagria": "2019-05-24T10:23:42.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:49:15.000Z",
      "dt_register": "2019-06-17T15:05:24.000Z",
      "dt_update": "2019-06-17T15:05:24.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40645934974851",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 94,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "570.20",
      "peso_final_carcaca_1": "152.30",
      "peso_final_carcaca_2": "158.70",
      "total_carcaca": "311.00",
      "rendimento": "54.54",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291936",
      "ind_dt_register_sagria": "2019-05-24T10:23:57.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:11:02.000Z",
      "dt_register": "2019-06-17T15:05:25.000Z",
      "dt_update": "2019-06-17T15:05:25.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40647495758776",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 95,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "544.20",
      "peso_final_carcaca_1": "162.50",
      "peso_final_carcaca_2": "160.10",
      "total_carcaca": "322.60",
      "rendimento": "59.28",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291937",
      "ind_dt_register_sagria": "2019-05-24T10:24:33.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:50:38.000Z",
      "dt_register": "2019-06-17T15:05:25.000Z",
      "dt_update": "2019-06-17T15:05:25.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40649056542701",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 96,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "548.20",
      "peso_final_carcaca_1": "156.30",
      "peso_final_carcaca_2": "164.70",
      "total_carcaca": "321.00",
      "rendimento": "58.56",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291938",
      "ind_dt_register_sagria": "2019-05-24T10:25:08.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:51:14.000Z",
      "dt_register": "2019-06-17T15:05:25.000Z",
      "dt_update": "2019-06-17T15:05:25.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40650617352671",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 97,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "563.20",
      "peso_final_carcaca_1": "153.90",
      "peso_final_carcaca_2": "158.50",
      "total_carcaca": "312.40",
      "rendimento": "55.47",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291939",
      "ind_dt_register_sagria": "2019-05-24T10:25:49.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:51:47.000Z",
      "dt_register": "2019-06-17T15:05:26.000Z",
      "dt_update": "2019-06-17T15:05:26.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40652178136597",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 98,
      "flag_contusao": "S",
      "sexo": "M",
      "peso_vivo": "574.20",
      "peso_final_carcaca_1": "168.90",
      "peso_final_carcaca_2": "174.70",
      "total_carcaca": "343.60",
      "rendimento": "59.84",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291940",
      "ind_dt_register_sagria": "2019-05-24T10:26:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:52:34.000Z",
      "dt_register": "2019-06-17T15:05:26.000Z",
      "dt_update": "2019-06-17T15:05:26.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40653738920523",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 99,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "507.20",
      "peso_final_carcaca_1": "156.70",
      "peso_final_carcaca_2": "159.50",
      "total_carcaca": "316.20",
      "rendimento": "62.34",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291941",
      "ind_dt_register_sagria": "2019-05-24T10:27:32.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:53:08.000Z",
      "dt_register": "2019-06-17T15:05:26.000Z",
      "dt_update": "2019-06-17T15:05:26.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40655299730497",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 100,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "571.20",
      "peso_final_carcaca_1": "161.10",
      "peso_final_carcaca_2": "165.70",
      "total_carcaca": "326.80",
      "rendimento": "57.21",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291942",
      "ind_dt_register_sagria": "2019-05-24T10:27:56.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:11:07.000Z",
      "dt_register": "2019-06-17T15:05:27.000Z",
      "dt_update": "2019-06-17T15:05:27.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40656860514424",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 101,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "550.20",
      "peso_final_carcaca_1": "168.70",
      "peso_final_carcaca_2": "176.30",
      "total_carcaca": "345.00",
      "rendimento": "62.70",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291943",
      "ind_dt_register_sagria": "2019-05-24T10:29:23.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:53:59.000Z",
      "dt_register": "2019-06-17T15:05:27.000Z",
      "dt_update": "2019-06-17T15:05:27.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40658421298351",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 102,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "559.20",
      "peso_final_carcaca_1": "154.90",
      "peso_final_carcaca_2": "165.10",
      "total_carcaca": "320.00",
      "rendimento": "57.22",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291944",
      "ind_dt_register_sagria": "2019-05-24T10:29:32.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:54:33.000Z",
      "dt_register": "2019-06-17T15:05:27.000Z",
      "dt_update": "2019-06-17T15:05:27.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40659982108329",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 103,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "572.20",
      "peso_final_carcaca_1": "171.50",
      "peso_final_carcaca_2": "174.90",
      "total_carcaca": "346.40",
      "rendimento": "60.54",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291945",
      "ind_dt_register_sagria": "2019-05-24T10:29:44.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:55:18.000Z",
      "dt_register": "2019-06-17T15:05:28.000Z",
      "dt_update": "2019-06-17T15:05:28.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40661542892257",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 104,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "557.20",
      "peso_final_carcaca_1": "167.50",
      "peso_final_carcaca_2": "175.30",
      "total_carcaca": "342.80",
      "rendimento": "61.52",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291946",
      "ind_dt_register_sagria": "2019-05-24T10:30:26.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:55:50.000Z",
      "dt_register": "2019-06-17T15:05:28.000Z",
      "dt_update": "2019-06-17T15:05:28.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40663103676185",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 105,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "576.20",
      "peso_final_carcaca_1": "166.90",
      "peso_final_carcaca_2": "172.90",
      "total_carcaca": "339.80",
      "rendimento": "58.97",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291947",
      "ind_dt_register_sagria": "2019-05-24T10:31:43.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:56:26.000Z",
      "dt_register": "2019-06-17T15:05:28.000Z",
      "dt_update": "2019-06-17T15:05:28.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40664664486167",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 106,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "586.20",
      "peso_final_carcaca_1": "166.90",
      "peso_final_carcaca_2": "176.30",
      "total_carcaca": "343.20",
      "rendimento": "58.55",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291948",
      "ind_dt_register_sagria": "2019-05-24T10:31:51.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:57:00.000Z",
      "dt_register": "2019-06-17T15:05:29.000Z",
      "dt_update": "2019-06-17T15:05:29.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40666225270096",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 107,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "568.20",
      "peso_final_carcaca_1": "161.70",
      "peso_final_carcaca_2": "167.10",
      "total_carcaca": "328.80",
      "rendimento": "57.87",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291949",
      "ind_dt_register_sagria": "2019-05-24T10:32:20.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:57:34.000Z",
      "dt_register": "2019-06-17T15:05:29.000Z",
      "dt_update": "2019-06-17T15:05:29.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40667786054025",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 108,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "566.20",
      "peso_final_carcaca_1": "164.10",
      "peso_final_carcaca_2": "174.10",
      "total_carcaca": "338.20",
      "rendimento": "59.73",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291950",
      "ind_dt_register_sagria": "2019-05-24T10:32:52.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:58:08.000Z",
      "dt_register": "2019-06-17T15:05:29.000Z",
      "dt_update": "2019-06-17T15:05:29.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40669346837954",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 109,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "587.20",
      "peso_final_carcaca_1": "159.90",
      "peso_final_carcaca_2": "163.70",
      "total_carcaca": "323.60",
      "rendimento": "55.11",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291951",
      "ind_dt_register_sagria": "2019-05-24T10:34:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T10:58:42.000Z",
      "dt_register": "2019-06-17T15:05:29.000Z",
      "dt_update": "2019-06-17T15:05:29.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40670907647941",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 110,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "565.20",
      "peso_final_carcaca_1": "162.30",
      "peso_final_carcaca_2": "164.70",
      "total_carcaca": "327.00",
      "rendimento": "57.86",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291952",
      "ind_dt_register_sagria": "2019-05-24T10:34:10.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:22:22.000Z",
      "dt_register": "2019-06-17T15:05:30.000Z",
      "dt_update": "2019-06-17T15:05:30.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40672468431871",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 111,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "558.20",
      "peso_final_carcaca_1": "169.90",
      "peso_final_carcaca_2": "169.50",
      "total_carcaca": "339.40",
      "rendimento": "60.80",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291953",
      "ind_dt_register_sagria": "2019-05-24T10:34:41.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:42:09.000Z",
      "dt_register": "2019-06-17T15:05:30.000Z",
      "dt_update": "2019-06-17T15:05:30.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40674029215801",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 112,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "559.20",
      "peso_final_carcaca_1": "161.10",
      "peso_final_carcaca_2": "168.30",
      "total_carcaca": "329.40",
      "rendimento": "58.91",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291954",
      "ind_dt_register_sagria": "2019-05-24T10:35:13.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:00:47.000Z",
      "dt_register": "2019-06-17T15:05:30.000Z",
      "dt_update": "2019-06-17T15:05:30.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40675590025792",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 113,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "588.20",
      "peso_final_carcaca_1": "153.10",
      "peso_final_carcaca_2": "158.90",
      "total_carcaca": "312.00",
      "rendimento": "53.04",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291955",
      "ind_dt_register_sagria": "2019-05-24T10:36:25.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:01:21.000Z",
      "dt_register": "2019-06-17T15:05:31.000Z",
      "dt_update": "2019-06-17T15:05:31.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40677150809723",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 114,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "557.20",
      "peso_final_carcaca_1": "161.10",
      "peso_final_carcaca_2": "167.30",
      "total_carcaca": "328.40",
      "rendimento": "58.94",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291956",
      "ind_dt_register_sagria": "2019-05-24T10:37:05.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:02:18.000Z",
      "dt_register": "2019-06-17T15:05:31.000Z",
      "dt_update": "2019-06-17T15:05:31.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40678711593654",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 115,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "549.20",
      "peso_final_carcaca_1": "31.50",
      "peso_final_carcaca_2": "156.30",
      "total_carcaca": "187.80",
      "rendimento": "34.20",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291957",
      "ind_dt_register_sagria": "2019-05-24T10:37:25.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:42:24.000Z",
      "dt_register": "2019-06-17T15:05:31.000Z",
      "dt_update": "2019-06-17T15:05:31.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40680272403649",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 116,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "571.20",
      "peso_final_carcaca_1": "159.70",
      "peso_final_carcaca_2": "170.90",
      "total_carcaca": "330.60",
      "rendimento": "57.88",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291958",
      "ind_dt_register_sagria": "2019-05-24T10:38:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:03:19.000Z",
      "dt_register": "2019-06-17T15:05:32.000Z",
      "dt_update": "2019-06-17T15:05:32.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40681833187581",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 117,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "500.20",
      "peso_final_carcaca_1": "176.10",
      "peso_final_carcaca_2": "181.30",
      "total_carcaca": "357.40",
      "rendimento": "71.45",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291959",
      "ind_dt_register_sagria": "2019-05-24T10:39:15.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:03:53.000Z",
      "dt_register": "2019-06-17T15:05:32.000Z",
      "dt_update": "2019-06-17T15:05:32.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40683393971513",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 118,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "563.20",
      "peso_final_carcaca_1": "163.30",
      "peso_final_carcaca_2": "170.30",
      "total_carcaca": "333.60",
      "rendimento": "59.23",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291960",
      "ind_dt_register_sagria": "2019-05-24T10:39:25.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:04:26.000Z",
      "dt_register": "2019-06-17T15:05:32.000Z",
      "dt_update": "2019-06-17T15:05:32.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40684954755445",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 119,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "601.20",
      "peso_final_carcaca_1": "147.70",
      "peso_final_carcaca_2": "154.50",
      "total_carcaca": "302.20",
      "rendimento": "50.27",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291961",
      "ind_dt_register_sagria": "2019-05-24T10:39:40.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:05:06.000Z",
      "dt_register": "2019-06-17T15:05:32.000Z",
      "dt_update": "2019-06-17T15:05:32.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40686515565445",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 120,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "560.91",
      "peso_final_carcaca_1": "161.90",
      "peso_final_carcaca_2": "168.30",
      "total_carcaca": "330.20",
      "rendimento": "58.87",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291962",
      "ind_dt_register_sagria": "2019-05-24T10:40:32.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:06:02.000Z",
      "dt_register": "2019-06-17T15:05:33.000Z",
      "dt_update": "2019-06-17T15:05:46.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "S",
      "flag_img": "S"
    },
    {
      "id": "40688076349378",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 121,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "527.20",
      "peso_final_carcaca_1": "157.70",
      "peso_final_carcaca_2": "162.90",
      "total_carcaca": "320.60",
      "rendimento": "60.81",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291963",
      "ind_dt_register_sagria": "2019-05-24T10:42:05.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:50:37.000Z",
      "dt_register": "2019-06-17T15:05:33.000Z",
      "dt_update": "2019-06-17T15:05:33.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40689637133311",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 122,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "552.20",
      "peso_final_carcaca_1": "160.70",
      "peso_final_carcaca_2": "165.30",
      "total_carcaca": "326.00",
      "rendimento": "59.04",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291964",
      "ind_dt_register_sagria": "2019-05-24T10:42:13.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:07:27.000Z",
      "dt_register": "2019-06-17T15:05:33.000Z",
      "dt_update": "2019-06-17T15:05:33.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40691197943315",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 123,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "567.20",
      "peso_final_carcaca_1": "154.70",
      "peso_final_carcaca_2": "162.70",
      "total_carcaca": "317.40",
      "rendimento": "55.96",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291965",
      "ind_dt_register_sagria": "2019-05-24T10:42:21.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:08:00.000Z",
      "dt_register": "2019-06-17T15:05:34.000Z",
      "dt_update": "2019-06-17T15:05:34.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40692758727249",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 124,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "564.20",
      "peso_final_carcaca_1": "177.30",
      "peso_final_carcaca_2": "180.70",
      "total_carcaca": "358.00",
      "rendimento": "63.45",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291966",
      "ind_dt_register_sagria": "2019-05-24T10:42:31.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:09:08.000Z",
      "dt_register": "2019-06-17T15:05:34.000Z",
      "dt_update": "2019-06-17T15:05:34.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40694319511183",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 125,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "557.20",
      "peso_final_carcaca_1": "167.90",
      "peso_final_carcaca_2": "178.10",
      "total_carcaca": "346.00",
      "rendimento": "62.10",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291967",
      "ind_dt_register_sagria": "2019-05-24T10:45:03.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:09:41.000Z",
      "dt_register": "2019-06-17T15:05:34.000Z",
      "dt_update": "2019-06-17T15:05:34.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40695880321191",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 126,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "605.20",
      "peso_final_carcaca_1": "163.10",
      "peso_final_carcaca_2": "171.30",
      "total_carcaca": "334.40",
      "rendimento": "55.25",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291968",
      "ind_dt_register_sagria": "2019-05-24T10:45:12.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:10:15.000Z",
      "dt_register": "2019-06-17T15:05:35.000Z",
      "dt_update": "2019-06-17T15:05:35.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40697441105126",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 127,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "582.20",
      "peso_final_carcaca_1": "162.90",
      "peso_final_carcaca_2": "167.30",
      "total_carcaca": "330.20",
      "rendimento": "56.72",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291969",
      "ind_dt_register_sagria": "2019-05-24T10:45:33.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:11:57.000Z",
      "dt_register": "2019-06-17T15:05:35.000Z",
      "dt_update": "2019-06-17T15:05:35.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40699001889061",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 128,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "585.20",
      "peso_final_carcaca_1": "163.30",
      "peso_final_carcaca_2": "171.30",
      "total_carcaca": "334.60",
      "rendimento": "57.18",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291970",
      "ind_dt_register_sagria": "2019-05-24T10:45:43.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:12:31.000Z",
      "dt_register": "2019-06-17T15:05:35.000Z",
      "dt_update": "2019-06-17T15:05:35.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40700562672996",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 129,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "558.20",
      "peso_final_carcaca_1": "170.70",
      "peso_final_carcaca_2": "179.70",
      "total_carcaca": "350.40",
      "rendimento": "62.77",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291971",
      "ind_dt_register_sagria": "2019-05-24T10:47:20.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:13:16.000Z",
      "dt_register": "2019-06-17T15:05:35.000Z",
      "dt_update": "2019-06-17T15:05:35.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40702123483009",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 130,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "568.20",
      "peso_final_carcaca_1": "155.90",
      "peso_final_carcaca_2": "159.90",
      "total_carcaca": "315.80",
      "rendimento": "55.58",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291972",
      "ind_dt_register_sagria": "2019-05-24T10:47:28.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:13:50.000Z",
      "dt_register": "2019-06-17T15:05:36.000Z",
      "dt_update": "2019-06-17T15:05:36.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40703684266945",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 131,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "533.20",
      "peso_final_carcaca_1": "159.90",
      "peso_final_carcaca_2": "161.90",
      "total_carcaca": "321.80",
      "rendimento": "60.35",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291973",
      "ind_dt_register_sagria": "2019-05-24T10:47:48.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:14:23.000Z",
      "dt_register": "2019-06-17T15:05:36.000Z",
      "dt_update": "2019-06-17T15:05:36.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40705245050881",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 132,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "568.20",
      "peso_final_carcaca_1": "159.50",
      "peso_final_carcaca_2": "163.90",
      "total_carcaca": "323.40",
      "rendimento": "56.92",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291974",
      "ind_dt_register_sagria": "2019-05-24T10:48:13.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:14:57.000Z",
      "dt_register": "2019-06-17T15:05:36.000Z",
      "dt_update": "2019-06-17T15:05:36.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40706805860898",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 133,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "601.20",
      "peso_final_carcaca_1": "169.30",
      "peso_final_carcaca_2": "176.30",
      "total_carcaca": "345.60",
      "rendimento": "57.49",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291975",
      "ind_dt_register_sagria": "2019-05-24T10:49:32.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:15:31.000Z",
      "dt_register": "2019-06-17T15:05:37.000Z",
      "dt_update": "2019-06-17T15:05:37.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40708366644835",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 134,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "588.20",
      "peso_final_carcaca_1": "170.30",
      "peso_final_carcaca_2": "176.30",
      "total_carcaca": "346.60",
      "rendimento": "58.93",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291976",
      "ind_dt_register_sagria": "2019-05-24T10:49:43.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:16:04.000Z",
      "dt_register": "2019-06-17T15:05:37.000Z",
      "dt_update": "2019-06-17T15:05:37.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40709927428772",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 135,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "553.20",
      "peso_final_carcaca_1": "167.50",
      "peso_final_carcaca_2": "174.30",
      "total_carcaca": "341.80",
      "rendimento": "61.79",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291977",
      "ind_dt_register_sagria": "2019-05-24T10:50:36.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:17:14.000Z",
      "dt_register": "2019-06-17T15:05:37.000Z",
      "dt_update": "2019-06-17T15:05:37.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40711488238793",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 136,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "585.20",
      "peso_final_carcaca_1": "160.10",
      "peso_final_carcaca_2": "162.70",
      "total_carcaca": "322.80",
      "rendimento": "55.16",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291978",
      "ind_dt_register_sagria": "2019-05-24T10:50:55.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:51:20.000Z",
      "dt_register": "2019-06-17T15:05:38.000Z",
      "dt_update": "2019-06-17T15:05:38.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40713049022731",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 137,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "557.20",
      "peso_final_carcaca_1": "165.50",
      "peso_final_carcaca_2": "175.90",
      "total_carcaca": "341.40",
      "rendimento": "61.27",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291979",
      "ind_dt_register_sagria": "2019-05-24T10:52:08.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:17:48.000Z",
      "dt_register": "2019-06-17T15:05:38.000Z",
      "dt_update": "2019-06-17T15:05:38.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40714609806669",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 138,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "586.20",
      "peso_final_carcaca_1": "158.70",
      "peso_final_carcaca_2": "166.70",
      "total_carcaca": "325.40",
      "rendimento": "55.51",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291980",
      "ind_dt_register_sagria": "2019-05-24T10:52:25.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:18:42.000Z",
      "dt_register": "2019-06-17T15:05:38.000Z",
      "dt_update": "2019-06-17T15:05:38.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40716170616694",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 139,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "547.20",
      "peso_final_carcaca_1": "157.50",
      "peso_final_carcaca_2": "159.30",
      "total_carcaca": "316.80",
      "rendimento": "57.89",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291981",
      "ind_dt_register_sagria": "2019-05-24T10:52:45.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:51:42.000Z",
      "dt_register": "2019-06-17T15:05:39.000Z",
      "dt_update": "2019-06-17T15:05:39.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40717731400633",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 140,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "542.20",
      "peso_final_carcaca_1": "153.70",
      "peso_final_carcaca_2": "158.70",
      "total_carcaca": "312.40",
      "rendimento": "57.62",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291982",
      "ind_dt_register_sagria": "2019-05-24T10:53:23.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:19:56.000Z",
      "dt_register": "2019-06-17T15:05:39.000Z",
      "dt_update": "2019-06-17T15:05:39.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40719292184572",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 141,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "533.20",
      "peso_final_carcaca_1": "167.10",
      "peso_final_carcaca_2": "173.90",
      "total_carcaca": "341.00",
      "rendimento": "63.95",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291983",
      "ind_dt_register_sagria": "2019-05-24T10:54:52.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:20:41.000Z",
      "dt_register": "2019-06-17T15:05:39.000Z",
      "dt_update": "2019-06-17T15:05:39.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40720852968511",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 142,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "574.20",
      "peso_final_carcaca_1": "151.70",
      "peso_final_carcaca_2": "159.90",
      "total_carcaca": "311.60",
      "rendimento": "54.27",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291984",
      "ind_dt_register_sagria": "2019-05-24T10:55:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:21:14.000Z",
      "dt_register": "2019-06-17T15:05:39.000Z",
      "dt_update": "2019-06-17T15:05:39.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40722413778541",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 143,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "512.20",
      "peso_final_carcaca_1": "149.50",
      "peso_final_carcaca_2": "156.90",
      "total_carcaca": "306.40",
      "rendimento": "59.82",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291985",
      "ind_dt_register_sagria": "2019-05-24T10:55:32.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:21:48.000Z",
      "dt_register": "2019-06-17T15:05:40.000Z",
      "dt_update": "2019-06-17T15:05:40.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40723974562481",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 144,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "544.20",
      "peso_final_carcaca_1": "152.30",
      "peso_final_carcaca_2": "158.10",
      "total_carcaca": "310.40",
      "rendimento": "57.04",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291986",
      "ind_dt_register_sagria": "2019-05-24T10:55:56.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:23:22.000Z",
      "dt_register": "2019-06-17T15:05:40.000Z",
      "dt_update": "2019-06-17T15:05:40.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40725535346421",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 145,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "560.20",
      "peso_final_carcaca_1": "156.70",
      "peso_final_carcaca_2": "158.50",
      "total_carcaca": "315.20",
      "rendimento": "56.27",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291987",
      "ind_dt_register_sagria": "2019-05-24T10:56:55.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:23:56.000Z",
      "dt_register": "2019-06-17T15:05:40.000Z",
      "dt_update": "2019-06-17T15:05:40.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40727096156455",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 146,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "575.20",
      "peso_final_carcaca_1": "160.90",
      "peso_final_carcaca_2": "171.30",
      "total_carcaca": "332.20",
      "rendimento": "57.75",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291988",
      "ind_dt_register_sagria": "2019-05-24T10:57:05.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:24:30.000Z",
      "dt_register": "2019-06-17T15:05:41.000Z",
      "dt_update": "2019-06-17T15:05:41.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40728656940396",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 147,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "570.20",
      "peso_final_carcaca_1": "160.50",
      "peso_final_carcaca_2": "167.90",
      "total_carcaca": "328.40",
      "rendimento": "57.59",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291989",
      "ind_dt_register_sagria": "2019-05-24T10:57:45.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:25:03.000Z",
      "dt_register": "2019-06-17T15:05:41.000Z",
      "dt_update": "2019-06-17T15:05:41.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40730217724337",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 148,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "528.20",
      "peso_final_carcaca_1": "149.00",
      "peso_final_carcaca_2": "155.50",
      "total_carcaca": "304.50",
      "rendimento": "57.65",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 6,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291990",
      "ind_dt_register_sagria": "2019-05-24T10:58:20.000Z",
      "ind_dt_register_pesagem": "2019-05-24T13:14:17.000Z",
      "dt_register": "2019-06-17T15:05:41.000Z",
      "dt_update": "2019-06-17T15:05:41.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40731778534375",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 149,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "563.20",
      "peso_final_carcaca_1": "163.90",
      "peso_final_carcaca_2": "173.70",
      "total_carcaca": "337.60",
      "rendimento": "59.94",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291991",
      "ind_dt_register_sagria": "2019-05-24T10:59:09.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:26:11.000Z",
      "dt_register": "2019-06-17T15:05:42.000Z",
      "dt_update": "2019-06-17T15:05:42.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40733339318317",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 150,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "585.20",
      "peso_final_carcaca_1": "170.70",
      "peso_final_carcaca_2": "172.90",
      "total_carcaca": "343.60",
      "rendimento": "58.71",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291992",
      "ind_dt_register_sagria": "2019-05-24T10:59:36.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:26:43.000Z",
      "dt_register": "2019-06-17T15:05:42.000Z",
      "dt_update": "2019-06-17T15:05:42.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40734900102259",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 151,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "562.20",
      "peso_final_carcaca_1": "159.50",
      "peso_final_carcaca_2": "170.90",
      "total_carcaca": "330.40",
      "rendimento": "58.77",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291993",
      "ind_dt_register_sagria": "2019-05-24T11:00:10.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:27:17.000Z",
      "dt_register": "2019-06-17T15:05:42.000Z",
      "dt_update": "2019-06-17T15:05:42.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40736460912301",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 152,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "577.20",
      "peso_final_carcaca_1": "168.90",
      "peso_final_carcaca_2": "178.10",
      "total_carcaca": "347.00",
      "rendimento": "60.12",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 2,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291994",
      "ind_dt_register_sagria": "2019-05-24T11:01:07.000Z",
      "ind_dt_register_pesagem": "2019-05-24T12:37:58.000Z",
      "dt_register": "2019-06-17T15:05:43.000Z",
      "dt_update": "2019-06-17T15:05:43.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40738021696244",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 153,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "556.20",
      "peso_final_carcaca_1": "158.30",
      "peso_final_carcaca_2": "165.30",
      "total_carcaca": "323.60",
      "rendimento": "58.18",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291995",
      "ind_dt_register_sagria": "2019-05-24T11:02:38.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:28:58.000Z",
      "dt_register": "2019-06-17T15:05:43.000Z",
      "dt_update": "2019-06-17T15:05:43.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40739582480187",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 154,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "527.20",
      "peso_final_carcaca_1": "144.30",
      "peso_final_carcaca_2": "151.70",
      "total_carcaca": "296.00",
      "rendimento": "56.15",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291996",
      "ind_dt_register_sagria": "2019-05-24T11:02:50.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:29:32.000Z",
      "dt_register": "2019-06-17T15:05:43.000Z",
      "dt_update": "2019-06-17T15:05:43.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40741143264130",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 155,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "557.20",
      "peso_final_carcaca_1": "157.30",
      "peso_final_carcaca_2": "167.50",
      "total_carcaca": "324.80",
      "rendimento": "58.29",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291997",
      "ind_dt_register_sagria": "2019-05-24T11:04:04.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:30:06.000Z",
      "dt_register": "2019-06-17T15:05:43.000Z",
      "dt_update": "2019-06-17T15:05:43.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40742704074177",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 156,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "555.20",
      "peso_final_carcaca_1": "159.10",
      "peso_final_carcaca_2": "167.50",
      "total_carcaca": "326.60",
      "rendimento": "58.83",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 1,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291998",
      "ind_dt_register_sagria": "2019-05-24T11:04:17.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:31:34.000Z",
      "dt_register": "2019-06-17T15:05:44.000Z",
      "dt_update": "2019-06-17T15:05:44.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40744264858121",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 157,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "560.20",
      "peso_final_carcaca_1": "157.10",
      "peso_final_carcaca_2": "165.30",
      "total_carcaca": "322.40",
      "rendimento": "57.55",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002291999",
      "ind_dt_register_sagria": "2019-05-24T11:05:20.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:32:24.000Z",
      "dt_register": "2019-06-17T15:05:44.000Z",
      "dt_update": "2019-06-17T15:05:44.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40745825642065",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 158,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "581.20",
      "peso_final_carcaca_1": "163.10",
      "peso_final_carcaca_2": "170.70",
      "total_carcaca": "333.80",
      "rendimento": "57.43",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292000",
      "ind_dt_register_sagria": "2019-05-24T11:05:40.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:32:58.000Z",
      "dt_register": "2019-06-17T15:05:44.000Z",
      "dt_update": "2019-06-17T15:05:44.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40747386452116",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 159,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "530.20",
      "peso_final_carcaca_1": "148.10",
      "peso_final_carcaca_2": "158.30",
      "total_carcaca": "306.40",
      "rendimento": "57.79",
      "raca_id": 44,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292001",
      "ind_dt_register_sagria": "2019-05-24T11:07:16.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:33:32.000Z",
      "dt_register": "2019-06-17T15:05:45.000Z",
      "dt_update": "2019-06-17T15:05:45.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40748947236061",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 160,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "592.20",
      "peso_final_carcaca_1": "164.10",
      "peso_final_carcaca_2": "172.30",
      "total_carcaca": "336.40",
      "rendimento": "56.81",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292002",
      "ind_dt_register_sagria": "2019-05-24T11:07:54.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:34:32.000Z",
      "dt_register": "2019-06-17T15:05:45.000Z",
      "dt_update": "2019-06-17T15:05:45.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40750508020006",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 161,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "558.20",
      "peso_final_carcaca_1": "156.90",
      "peso_final_carcaca_2": "162.30",
      "total_carcaca": "319.20",
      "rendimento": "57.18",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292003",
      "ind_dt_register_sagria": "2019-05-24T11:09:01.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:35:23.000Z",
      "dt_register": "2019-06-17T15:05:45.000Z",
      "dt_update": "2019-06-17T15:05:45.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40752068830061",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 162,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "524.20",
      "peso_final_carcaca_1": "144.90",
      "peso_final_carcaca_2": "150.90",
      "total_carcaca": "295.80",
      "rendimento": "56.43",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 4,
      "conformacao_id": 5,
      "maturidade_id": 2,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292004",
      "ind_dt_register_sagria": "2019-05-24T11:09:11.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:36:14.000Z",
      "dt_register": "2019-06-17T15:05:46.000Z",
      "dt_update": "2019-06-17T15:05:46.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40753629614007",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 163,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "583.20",
      "peso_final_carcaca_1": "161.10",
      "peso_final_carcaca_2": "166.10",
      "total_carcaca": "327.20",
      "rendimento": "56.10",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292005",
      "ind_dt_register_sagria": "2019-05-24T11:09:59.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:36:48.000Z",
      "dt_register": "2019-06-17T15:05:46.000Z",
      "dt_update": "2019-06-17T15:05:46.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    },
    {
      "id": "40755190397953",
      "track_id": "6806744600041020190524030000089644",
      "nr_sequencial_ind": 164,
      "flag_contusao": "N",
      "sexo": "M",
      "peso_vivo": "598.20",
      "peso_final_carcaca_1": "165.30",
      "peso_final_carcaca_2": "176.30",
      "total_carcaca": "341.60",
      "rendimento": "57.10",
      "raca_id": 1,
      "categoria_id": 1,
      "acabamento_id": 3,
      "conformacao_id": 5,
      "maturidade_id": 3,
      "destino_id": 1,
      "mercado_id": 1,
      "dt_abate": "2019-05-24T03:00:00.000Z",
      "st_sisbov": "SB-EX",
      "st_chip": null,
      "ind_cod_barra": "R0000002292006",
      "ind_dt_register_sagria": "2019-05-24T11:10:16.000Z",
      "ind_dt_register_pesagem": "2019-05-24T11:37:22.000Z",
      "dt_register": "2019-06-17T15:05:46.000Z",
      "dt_update": "2019-06-17T15:05:46.000Z",
      "ia_classificacao_id": 0,
      "ia_conformacao_id": 0,
      "id_dif_motivo": 1,
      "flag_inconsistencia": "N",
      "flag_img": "S"
    }
  ],
  "industry": {
    "id": "1",
    "name": "Ecotrace",
    "name_official": "Ecotrace S/A",
    "track_id": null,
    "document_type": null,
    "document_number": "68067446000410",
    "ie": null,
    "email": "ti@ecotrace.info",
    "phone": null,
    "latitude": null,
    "longitude": null,
    "logo": "https://firebasestorage.googleapis.com/v0/b/portal-ecotrace-dev.appspot.com/o/app-resources%2Flogo-ecotrace.png?alt=media&token=2a565bf9-da29-4de4-a137-3ffde5713d95",
    "obd": null,
    "address_city": "Vinhedo",
    "address_compl": null,
    "address_neighborhood": null,
    "address_number": null,
    "address_state": "SP",
    "address_street": null,
    "address_zipcode": null,
    "database_db": null,
    "database_password": null,
    "database_user": null,
    "database_host": null,
    "created_at": "2019-08-16 01:00:46",
    "updated_at": "2019-08-16 15:31:29"
  },
  "negotiation": null,
  "track_id": "6806744600041020190524030000089644",
  "produtor": {
    "cpf_cnpj": "1234562389",
    "nome_razaosocial": "JOSE DA SILVA SANTOS",
    "ie": "321123321",
    "nr_car": "SP354110932CCABBC4878414A938D726A120CC163"
  },
  "industria": {
    "cnpj": "68067446000410",
    "nr_op": "201905242960",
    "nr_escala_abate": 3,
    "sif_sie": 2960,
    "nr_ordem_compra": 0,
    "nr_lote_abate": "89644"
  },
  "fazenda": {
    "nome": "FAZENDA ECOTRACE",
    "endereco": "FAZENDA ECOTRACE",
    "cidade": "VINHEDO",
    "estado": "SP",
    "cod_municipio": 9999,
    "cep": "16670-000",
    "email": null,
    "nr_incra": null,
    "nr_licenca_operacao": null,
    "nr_licenca_ambiental": null,
    "nr_nirf": null,
    "nr_lar_lau": null
  },
  "complemento": {
    "dt_embarque": null,
    "tipo_negociacao_id": null,
    "jejum": null,
    "tipo_producao_id": null,
    "dt_pagamento": null,
    "preco_negociado": null
  },
  "dt_abate": "2019-05-24 00:00:00",
  "media_peso_vivo": "560.91",
  "media_peso_carcaca": "327.05",
  "total_peso_carcaca": "32705.00",
  "total_arroba": "2180.33",
  "media_arroba": "21.80",
  "media_rc": "58.31",
  "qtde_cab": 100,
  "qtde_cab_escala": 100,
  "sexo": "M",
  "dt_producao": null,
  "dt_validade": null,
  "hr_inicio": "2019-06-17T10:27:15.000Z",
  "hr_fim": "2019-06-17T13:14:18.000Z",
  "tempo_total": 2,
  "nr_seq_inicial_animal": 0,
  "nr_seq_final_animal": 0,
  "dt_register": null,
  "dt_update": null,
  "flag_enviado": "N",
  "dt_enviado": null,
  "hash_monitoramento": "64678",
  "hash_blockchain": null,
  "dt_register_ind": "2019-06-17T15:05:15.000Z",
  "dt_update_ind": "2019-08-19T13:14:43.000Z",
  "is_approved": true,
  "total_contusoes": 10,
  "porcentagem_contusoes": "10.00",
  "flag_inconsistencia": true,
  "classificacao_lote": 0,
  "acabamento": {
    "desejavel": {
      "total": 10,
      "percent": 20
    },
    "toleravel": {
      "total": 10,
      "percent": 20
    },
    "indesejavel": {
      "total": 10,
      "percent": 60
    }
  }
}